import React from "react";
import { useDispatch } from "react-redux";
import { removeFromWishlist } from "../../redux/orebiSlice";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
} from "@material-tailwind/react";

const Wishlist = ({ item, onDelete }) => {
  const dispatch = useDispatch();

  // const handleAddToWishlist = () => {
  //   dispatch(addToWishlist({ id: item._id, productName: item.name })); // Menambahkan item ke wishlist dengan dispatch dan action creator addToWishlist
  // };

  return (
    <Card className="w-48">
      <CardHeader shadow={false} floated={false} className="h-40">
        <img
          src={item.content.product.product_image}
          alt="productImage"
          className="h-full w-full object-cover"
        />
      </CardHeader>
      <CardBody>
        <div className="mb-2 flex items-center justify-between">
          <Typography color="blue-gray" className="font-medium">
            {item.content.content_title}
          </Typography>
          <Typography color="blue-gray" className="font-medium">
            ${item.content.price}
          </Typography>
        </div>
        {/* <Typography
          variant="small"
          color="gray"
          className="font-normal opacity-75"
        >
          Warna Ireng
        </Typography> */}
      </CardBody>
      <CardFooter className="pt-0">
        {/* <Button
          // onClick={handleAddToWishlist} // Menjalankan fungsi handleAddToWishlist saat tombol "Tambahkan ke Wishlist" di-klik
          ripple={false}
          fullWidth={true}
          className="bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
        >
          Tambahkan ke Wishlist
        </Button> */}
        <div className="relative flex items-center">
          <Button
            onClick={onDelete} // Use onDelete prop to trigger the delete function
            ripple={false}
            fullWidth={true}
            className="bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
          >
            Hapus
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

export default Wishlist;
